"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareVehicleToggle = exports.Checkbox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hideFocusOnMouseClick = require("../../../../packages/hideFocusOnMouseClick");
const Checkbox = exports.Checkbox = _styledComponents.default.div`
  background-repeat: no-repeat;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  height: 10px;
  width: 10px;
  border: 1px solid black;
`;
const CompareVehicleToggle = exports.CompareVehicleToggle = _styledComponents.default.label`
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  & > span {
    margin-left: 10px;
    display: inline-block;
    span {
      white-space: nowrap;
    }
  }
  input {
    height: 0;
    width: 0;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    body:not(.${_hideFocusOnMouseClick.HIDE_FOCUS_CLASS}) &:focus + ${Checkbox} {
      box-shadow: rgb(21 156 228 / 70%) 0px 0px 0px 2px;
    }
  }
  input:checked + ${Checkbox} {
    background-position: center center;
    background-color: black;
  }
`;